import { getBasketData } from "./api/getBasketData";
import { hasV2Basket } from "./hasV2Basket";

export async function isSameBasketEvent(cmsEventId: number) {

  const hasBasket = await hasV2Basket();
  if (!hasBasket) {
    return false;
  }
  const { success, data } = await getBasketData();
  if (!success) {
    //TODO: Report an error!
    return false;
  }

  return data.orderItems && !data.orderItems.some((item) => item.cmsContentId !== cmsEventId);
}
